<template>

<div class="tool" :class="{'is-dark': isDark, 'is-aiding': isAiding}">

	<com-progress />
	<com-profile v-if="!$isPatient" v-show="isProfiling" />
	<com-aid v-if="isAiding" />

	<button class="tool-help no-print" v-if="$isPatient" v-on:click="showHelp = true" title="Navigation tips">?</button>

	<com-help v-if="showHelp" v-on:close="onHelpClose" />

</div>

</template>

<script>

import comProgress from './tool/Progress'
import comAid from './tool/Aid'
import comProfile from './tool/Profile'
import comHelp from './tool/Help'

export default {

	components: {

		'com-aid': comAid,
		'com-profile': comProfile,
		'com-progress': comProgress,
		'com-help': comHelp

	},

	data: function() {

		return {
			showHelp: false
		}

	},

	created: function() {

		if (this.$store.getters['session/validated']) {

			if(!this.$isPatient) this.$store.commit('session/reset')

		} else {

			this.$router.push({
				name: 'Home'
			})

		}

	},

	mounted: function() {

		// Show the navigation tips on entering the tool, unless the user has
		// chosen not to see them again. Patient flow only.
		if (this.$isPatient && !localStorage.getItem('ifrap_hide_help')) {
			this.showHelp = true
		}

	},

	methods: {

		onHelpClose: function(dontShow) {

			if (dontShow) localStorage.setItem('ifrap_hide_help', '1')
			this.showHelp = false

		}

	},

	computed: {

		isDark: function() {

			if (this.currentAlert) {

				var type = (this.currentAlert === true) ? this.$store.getters['session/alerts/dynamic'].type : this.alerts[this.currentAlert].type
				
				return this.$_.contains([this.$constants.alert.type.warning, this.$constants.alert.type.error], type)

			} else {

				return false

			}

		}

	}

}

</script>

<style>

.tool {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	overflow: hidden;
	background-color: #fff;
	transition: all 300ms ease-in-out;
}

@media print {

	.tool {
		position: relative;
		left: auto;
		top: auto;
		overflow: visible;
		height: auto;
	}

}

.tool.is-dark  {
	background-color: #343434;
}

.tool-help {
	position: fixed;
	right: 24px;
	bottom: 24px;
	width: 48px;
	height: 48px;
	border-radius: 50%;
	background-color: var(--aid-color);
	color: #343434;
	font-size: 26px;
	font-weight: 700;
	line-height: 48px;
	text-align: center;
	cursor: pointer;
	z-index: 1500;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
	transition: filter 300ms ease-in-out;
}

.tool-help:hover {
	filter: brightness(90%);
}

.is-mobile .tool-help {
	right: 16px;
	bottom: 70px;
	width: 40px;
	height: 40px;
	font-size: 20px;
	line-height: 40px;
}

:root {
	--primary-color: #00ceff;
	--profile-color: #00ceff;
	--aid-color: #5af2cf;
}

.is-patient {
	--primary-color: #F69B3B;
	--profile-color: #F69B3B;
	--aid-color: #F69B3B;
}

/*
:root {
	--primary-color: #F8A533;
	--profile-color: #F8A533;
	--aid-color: #F8A533;
}
*/

.tool:has(.aid.is-focus) .progress {
	filter: blur(5px);
	pointer-events: none;
}

</style>
